import {
  STATIC_GET,
  STATIC_UDPATE
} from '../actions/webStatic'

import {
  API_BASE_URL,
  STATIC_GET_URL,
  STATIC_UPDATE_URL
} from "../variables"

import axios from 'axios'

const state = {};
const mutations = {};
const getters = {};
const actions = {
  [STATIC_GET]: ({commit, state, getters}, payload) => {
    return axios({
      url: API_BASE_URL + STATIC_GET_URL,
      method: "GET",
      headers: {
        'Authorization': 'Bearer ' + getters.getUserAccessToken
      }
    })
  },
  [STATIC_UDPATE]: ({commit, state, getters}, payload) => {
    return axios({
      url: API_BASE_URL + STATIC_UPDATE_URL,
      method: "PUT",
      data: payload,
      headers: {
        'Authorization': 'Bearer ' + getters.getUserAccessToken
      }
    })
  },
}
export default {
  mutations,
  actions,
  getters,
  state
}